import * as React from 'react';
const DropdownContext = /*#__PURE__*/React.createContext(null);
export { DropdownContext };


//////////////////
// WEBPACK FOOTER
// ./node_modules/@mui/base/useDropdown/DropdownContext.js
// module id = 304
// module chunks = 31